import { __assign, __awaiter, __generator, __read } from "tslib";
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
import { fetchPeopleCardConfig, } from '@office-start/people-card-config-service';
import { runBeforeLayout } from '@office-start/performance-utility';
import { IDLE_MEDIUM_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { useLegacyFluentTheme } from '@office-start/theming-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import React, { useEffect, useMemo, useRef, useState } from 'react';
export function usePeopleCard(showPeopleCard) {
    if (showPeopleCard === void 0) { showPeopleCard = true; }
    var componentContext = useOfficeComponentContext().data;
    var userEntitlements = useUserEntitlements().data;
    var theme = useLegacyFluentTheme();
    var workHandle = useRef(null);
    var _a = __read(useState(false), 2), canRender = _a[0], setCanRender = _a[1];
    useEffect(function () {
        workHandle.current = scheduleWork(function () {
            return runBeforeLayout(function () {
                var _a;
                if (showPeopleCard &&
                    componentContext &&
                    !componentContext.inMockMode &&
                    ((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.isCommercialUser)) {
                    import('@1js/midgard-bootstrapper/lib/Bootstrapper')
                        .then(function (mod) {
                        return bootstrap(componentContext, userEntitlements.result, mod);
                    })
                        .then(function () {
                        if (window.LPC &&
                            window.LPC.LivePersonaCardHoverTargetV2 &&
                            window.LPC.loadTheme) {
                            setCanRender(true);
                        }
                    });
                }
            });
        }, IDLE_MEDIUM_PRIORITY);
        return function () {
            var _a;
            (_a = workHandle.current) === null || _a === void 0 ? void 0 : _a.cancel();
        };
    }, [componentContext, showPeopleCard, userEntitlements]);
    return useMemo(function () {
        if (canRender && theme) {
            window.LPC.loadTheme(theme);
            var PeopleCard = function (props) {
                var _a;
                var LivePersonaCardHoverTargetV2 = window.LPC.LivePersonaCardHoverTargetV2;
                return (React.createElement(LivePersonaCardHoverTargetV2, { cardParameters: __assign({ personaInfo: {
                            identifiers: __assign(__assign({}, (props.useUpnInLpc
                                ? { Upn: props.upn }
                                : { Smtp: props.upn })), { PersonaType: 'User' }),
                        }, externalAppSessionCorrelationId: componentContext === null || componentContext === void 0 ? void 0 : componentContext.correlationId, behavior: {
                            onCardOpen: (_a = props.onTrigger) !== null && _a !== void 0 ? _a : null,
                            onCardClose: null,
                            disableHover: false,
                        } }, (props.tabIndex && { tabIndex: props.tabIndex })) }, props.children));
            };
            return PeopleCard;
        }
        return undefined;
    }, [canRender, componentContext, theme]);
}
function bootstrap(officeComponentContext, userEntitlements, bootstrapper) {
    return __awaiter(this, void 0, void 0, function () {
        var peopleCardConfig, identity, isGcc, config, initPromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchPeopleCardConfig()];
                case 1:
                    peopleCardConfig = _a.sent();
                    return [4 /*yield*/, fetchIdentity()];
                case 2:
                    identity = _a.sent();
                    isGcc = (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.IsGovernment) || false;
                    config = {
                        actionCallbacks: undefined,
                        culture: officeComponentContext.preferredCulture,
                        region: (peopleCardConfig === null || peopleCardConfig === void 0 ? void 0 : peopleCardConfig.region) || '',
                        clientType: (peopleCardConfig === null || peopleCardConfig === void 0 ? void 0 : peopleCardConfig.clientType) || '',
                        clientContextType: (peopleCardConfig === null || peopleCardConfig === void 0 ? void 0 : peopleCardConfig.clientContextType) || '',
                        clientCorrelationId: officeComponentContext.correlationId,
                        getAuthToken: function (onSuccess, onFailure) {
                            getAuthToken(officeComponentContext.getAccessToken, function (token, error) {
                                if (token) {
                                    onSuccess(token, officeComponentContext.correlationId);
                                }
                                else {
                                    onFailure(error, officeComponentContext.correlationId);
                                }
                            });
                        },
                        isConsumer: identity === null || identity === void 0 ? void 0 : identity.isMsa,
                        complianceEnvironment: getLpcEnvironment(isGcc, peopleCardConfig),
                    };
                    initPromise = bootstrapper
                        .initializeLivePersonaCardAsync(config)
                        .then(function () {
                        /* TODO: Add telemetry */
                    })
                        .catch(function (err) {
                        /* TODO: Add error telemetry*/
                    });
                    return [2 /*return*/, initPromise];
            }
        });
    });
}
function getAuthToken(accessTokenFunction, callback) {
    accessTokenFunction('Loki').then(function (tokenResponse) {
        callback(tokenResponse.token, tokenResponse.error ? "Error : ".concat(tokenResponse.error) : '');
    });
}
function getLpcEnvironment(isGcc, peopleCardConfig) {
    var environmentType = (peopleCardConfig === null || peopleCardConfig === void 0 ? void 0 : peopleCardConfig.complianceEnvironment) || 'Unknown';
    if (isGcc && environmentType === 'Prod') {
        return 'GccModerate';
    }
    return environmentType;
}
//# sourceMappingURL=usePeopleCard.js.map